export const loaderEventKeys = {
	SHOW_LOADER: 'show-loader',
	HIDE_LOADER: 'hide-loader',
}
export const showLoader = (message = 'Loading...') => {
	const event = new CustomEvent(loaderEventKeys.SHOW_LOADER, {
		detail: { message },
	})
	window.dispatchEvent(event)
}

export const hideLoader = () => {
	const event = new CustomEvent(loaderEventKeys.HIDE_LOADER)
	window.dispatchEvent(event)
}
